module.exports = __webpack_public_path__ + "static/media/blog_58.f3916a5d.webp";